import Composition from '../utils/Composition';

export const maskFactory = 
	barAnalyzer => 
		(data, options) => 
			Composition
				.create(data)
				.rawBars()
				.map(bar => barAnalyzer(bar, options));


// WEBPACK FOOTER //
// ./D:/Repos/university/my-composer/app/plugins/GA/lib/masks/helpers.js